<template>
    <CompassFeatureBanner
        v-if="reportsAvailable.length > 0"
        class="report-banner"
        illustration="/ressources/logged/img/illustrations/reporting.svg"
        :title="$t.__('report.ReportBanner.try_new_reports')"
    >
        <div class="report-banner__buttons">
            <div
                v-for="report in reportsAvailablesSorted"
                :key="`report-${report.code}`"
                class="report-banner__buttons-button"
            >
                <CompassButton
                    :label="$t.__(report.keyName)"
                    type="tertiary-contrast"
                    @click="
                        report.upsell
                            ? openFeatureModal(report.code)
                            : redirectToNewReport(report.id)
                    "
                >
                    <template #prefix v-if="report.upsell">
                        <CompassFeatureBadge size="small" variant="upsell" :isInteractive="false" />
                    </template>
                </CompassButton>
            </div>
        </div>
    </CompassFeatureBanner>
</template>

<script>
import reportsMixins from 'mixins/reports/reportsMixins.js';
export default {
    mixins: [reportsMixins],
    props: {
        pricingLevel: {
            type: Number,
            required: true,
        },
        pricingPlan: {
            type: String,
            required: true,
        },
        licence: {
            type: String,
            required: true,
        },
        reportCode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentReportCode: this.reportCode,
        };
    },
    computed: {
        reportsAvailable() {
            return this.getLuzmoReportsAvailableForAReport(
                this.pricingLevel,
                this.pricingPlan.toLowerCase(),
                this.licence,
                this.currentReportCode,
            );
        },
        reportsAvailablesSorted() {
            const reportsAvailableSorted = [...this.reportsAvailable];
            return reportsAvailableSorted.sort((reportAvailableA, reportAvailableB) => {
                if (reportAvailableA.upsell && !reportAvailableB.upsell) {
                    return 1;
                }
                if (!reportAvailableA.upsell && reportAvailableB.upsell) {
                    return -1;
                }
                return 0;
            });
        },
    },
    watch: {
        reportsAvailable() {
            this.setPaddingToContainer();
        },
    },
    created() {
        window.addEventListener('resize', () => this.setPaddingToContainer());
        window.addEventListener('updateStatsReport', (event) => this.updateReportCode(event));
        this.setPaddingToContainer();
    },
    destroyed() {
        window.addEventListener('resize', () => this.setPaddingToContainer());
        window.removeEventListener('updateStatsReport', (event) => this.updateReportCode(event));
    },
    methods: {
        openFeatureModal(reportCode) {
            window.sellsyapp.$store.state.popupPanel.featureModal.props = {
                feature: reportCode,
            };
            window.sellsyapp.$store.state.popupPanel.featureModal.display = true;
        },
        redirectToNewReport(reportId) {
            const reportLink = this.$router.resolve({
                name: 'reports.dashboard',
                params: { id: reportId },
            });
            window.open(reportLink.href, '_blank');
        },
        updateReportCode() {
            this.currentReportCode = event.detail.reportCode;
        },
        setPaddingToContainer() {
            this.$nextTick(() => {
                const reportBannerHeight =
                    document.getElementsByClassName('report-banner-container')[0].offsetHeight;
                document.getElementsByClassName(
                    'report-container',
                )[0].style.paddingTop = `${reportBannerHeight}px`;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.report-banner {
    &::v-deep {
        .compass-feature-banner__illustration {
            img {
                z-index: 0;
            }
        }
        .compass-feature-banner__content-title {
            margin-bottom: var(--spacing-3);
        }
    }

    &__buttons {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-2);

        &-button {
            position: relative;

            &::v-deep {
                .compass-feature-badge {
                    cursor: pointer;
                    position: absolute;
                    top: -4px;
                    right: -4px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.report-container:has(.report-banner) {
    .report-banner-container {
        position: absolute;
        top: 61px;
        left: 64px;
        right: 0;
    }
}
</style>
